<template>
  <article
    class="room-status-diagram_card"
    :style="{
      width: ROOM_STATUS_CARD_WIDTH + 'px',
      height: ROOM_STATUS_CARD_HEIGHT + 'px',
      top: (roomInfo.room_y * ROOM_STATUS_CARD_HEIGHT) / roomInfo.height + 'px',
      left: (roomInfo.room_x * ROOM_STATUS_CARD_WIDTH) / roomInfo.width + 'px',
      backgroundColor: cardBgColor
    }"
    :class="cardClassList"
    @click="onClickCard"
  >
    <div
      class="room-status-diagram_indicator"
      :style="{
        backgroundColor: indicatorBgColor
      }"
    ></div>
    <div class="room-status-diagram_card_content">
      <div class="hotel-code">{{ roomInfo?.room_level_name }}</div>
      <div class="room-number">{{ roomInfo?.room_num }}</div>
      <div
        v-if="!roomInfo.empty_room || roomInfo.ooo"
        class="booking-date-range"
      >
        <span v-if="roomInfo.depart || roomInfo.in_house || roomInfo.ooo">
          {{ getDayMonthFromDate(roomInfo?.from_date) }} -
          {{ getDayMonthFromDate(roomInfo?.to_date) }}
        </span>
        <span v-else-if="roomInfo.arrive">
          {{ getDayMonthFromDate(roomInfo?.from_date_next) }} -
          {{ getDayMonthFromDate(roomInfo?.to_date_next) }}
        </span>
      </div>
      <div class="tag-icon-list">
        <IconSvg
          v-for="icon in cardIconList"
          :key="icon"
          :icon="icon"
          has-fill
          class="tag-icon-item"
        />
      </div>
    </div>
    <div
      v-if="roomInfo.group_color"
      class="room-status-diagram_group-indicator"
      :style="{ color: roomInfo.group_color }"
    ></div>
  </article>
</template>
<script>
import IconSvg from '@/components/IconSvg/index.vue'

// eslint-disable-next-line no-unused-vars
import {
  ROOM_STATUS_COLORS,
  ROOM_TAG_ICONS,
  // eslint-disable-next-line no-unused-vars
  ROOM_STATUS_VALUE,
  // eslint-disable-next-line no-unused-vars
  ROOM_BOOKING_TYPE_VALUE
} from '../constants'

// const ROOM_STATUS_CARD_WIDTH = 180
// const ROOM_STATUS_CARD_HEIGHT = 132

const ROOM_STATUS_CARD_WIDTH = 180
const ROOM_STATUS_CARD_HEIGHT = 100

export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { IconSvg },
  props: {
    /**
     * @typedef {Object}
     * @property {Number} room_id
     * @property {string} room_num
     * @property {String} room_x
     * @property {String} room_y
     * @property {String} room_level_name
     * @property {String} from_date
     * @property {String} to_date
     * @property {String} from_date_next
     * @property {String} to_date_next
     * @property {String} booking_room_status @enum ['1', '2', '3', '4']
     * 1 - Đã đặt; 2 - Đang ở; 3 - Hủy; 4 - Checkout
     * @property {String} @enum ['VCI', 'VC', '', ...]
     * @property {String} group_color
     * @property {Boolean} foc @enum [true, false] - free or not
     */
    roomInfo: {
      required: false,
      type: Object
    }
  },
  data() {
    return {}
  },
  computed: {
    ROOM_TAG_ICONS() {
      return ROOM_TAG_ICONS
    },
    ROOM_STATUS_CARD_WIDTH() {
      return ROOM_STATUS_CARD_WIDTH
    },
    ROOM_STATUS_CARD_HEIGHT() {
      return ROOM_STATUS_CARD_HEIGHT
    },
    ROOM_BOOKING_TYPE_VALUE() {
      return ROOM_BOOKING_TYPE_VALUE
    },

    cardBgColor() {
      if (this.roomInfo.empty_room) {
        if (this.roomInfo.ooo) {
          return ROOM_STATUS_COLORS.OOO
        } else {
          return ROOM_STATUS_COLORS.AVAILABLE
        }
      } else if (
        this.roomInfo.arrive ||
        this.roomInfo.depart ||
        this.roomInfo.in_house
      ) {
        return ROOM_STATUS_COLORS.BOOKED
      } else if (this.roomInfo.foc) {
        return ROOM_STATUS_COLORS.FOC
      }

      return '#fff'
    },
    cardClassList() {
      const cardClassPrefix = 'room-status-diagram_card--'

      const cardClassList = []
      if (!this.roomInfo.assign) {
        cardClassList.push(cardClassPrefix + 'non-assign')
      } else if (this.roomInfo.empty_room) {
        if (this.roomInfo.ooo) {
          cardClassList.push(cardClassPrefix + 'ooo')
        } else {
          cardClassList.push(cardClassPrefix + 'vacant')
        }
      } else if (
        this.roomInfo.arrive ||
        this.roomInfo.depart ||
        this.roomInfo.in_house
      ) {
        cardClassList.push(cardClassPrefix + 'occupied')
      } else if (this.roomInfo.foc) {
        cardClassList.push(cardClassPrefix + 'foc')
      }

      // switch (this.roomInfo.booking_room_status) {
      //   case ROOM_STATUS_VALUE.DIRTY:
      //     cardClassList.push(cardClassPrefix + 'dirty')
      //     break
      //   case ROOM_STATUS_VALUE.CLEAN:
      //     cardClassList.push(cardClassPrefix + 'clean')
      //     break
      //   case ROOM_STATUS_VALUE.READY:
      //     cardClassList.push(cardClassPrefix + 'ready')
      //     break
      //   default:
      //     break
      // }

      return cardClassList
    },
    indicatorBgColor() {
      switch (this.roomInfo.room_status) {
        case ROOM_STATUS_VALUE.DIRTY:
          return ROOM_STATUS_COLORS.DIRTY
        case ROOM_STATUS_VALUE.CLEAN:
          return ROOM_STATUS_COLORS.CLEAN
        case ROOM_STATUS_VALUE.READY:
          return ROOM_STATUS_COLORS.READY
        default:
          return 'transparent'
      }
    },
    cardIconList() {
      const iconList = []

      if (this.roomInfo.ooo) {
        iconList.push(ROOM_TAG_ICONS.OOO)
        return iconList
      }
      if (this.roomInfo.empty_room) {
        iconList.push(ROOM_TAG_ICONS.AVAILABLE_ROOM)
      }

      if (this.roomInfo.depart) {
        iconList.push(ROOM_TAG_ICONS.DEPART)
      }

      if (this.roomInfo.arrive) {
        iconList.push(ROOM_TAG_ICONS.ARRIVE)
      }

      if (this.roomInfo.in_house) {
        iconList.push(ROOM_TAG_ICONS.IN_HOUSE)
      }

      // if (this.roomInfo.long_stay) {
      //   iconList.push(ROOM_TAG_ICONS.LONG_STAY)
      // }

      // if (this.roomInfo.short_stay) {
      //   iconList.push(ROOM_TAG_ICONS.SHORT_STAY)
      // }

      if (this.mission_warn_comment_mes) {
        iconList.push(ROOM_TAG_ICONS.MISSION_WARN_COMMENT_MESS)
      }

      if (this.roomInfo.oos) {
        iconList.push(ROOM_TAG_ICONS.OOS)
      }

      if (this.roomInfo.diff) {
        iconList.push(ROOM_TAG_ICONS.DIFF)
      }
      if (this.roomInfo.lock_transfer) {
        iconList.push(ROOM_TAG_ICONS.LOCK)
      }

      return iconList
    }
  },

  mounted() {},
  methods: {
    /** getDayMonthFromDate
     * @returns {String}
     * eg: '2023-01-01' -> '01-01'
     */
    getDayMonthFromDate(str) {
      return str ? this.$moment(str).format('DD/MM') : null
    },

    onClickCard() {
      this.$emit('click')
    }
  }
}
</script>
<style lang="scss">
@import '~@/styles/variables.scss';

.room-status-diagram {
  &_card {
    user-select: none;
    cursor: pointer;
    &:hover {
      outline: 2px solid rgb(var(--das-color-primary));
      outline-offset: 1px;
    }

    border-radius: 8px;
    border: 1px solid var(--das-border-color);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    position: relative;
    box-sizing: border-box;
    overflow: clip;
    display: grid;
    grid-template-columns: auto 1fr;
    position: absolute;

    &--non-assign {
      color: #fff;
      background: #aeaeae !important;
      pointer-events: none;

      .tag-icon-list .tag-icon-item {
        fill: #fff !important;
      }
    }

    &--vacant {
    }

    &--occupied {
      color: #fff;
    }

    &--ooo {
      color: #fff;
      .room-status-diagram_indicator {
        background: inherit !important;
      }
    }

    &--foc {
      color: #fff;
    }

    &--ooo,
    &--foc,
    &--occupied {
      .tag-icon-list .tag-icon-item {
        fill: #fff !important;
      }
    }
  }

  &_card_content {
    padding: 10px 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    // justify-content: space-between;
    letter-spacing: 0.05em;
    overflow: hidden;

    .room-number {
      font-weight: 600;
      font-size: 12px !important;
    }

    .hotel-code,
    .booking-date-range {
      font-weight: 400;
      font-size: 12px !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .tag-icon-list {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      gap: 4px;

      .tag-icon-item {
        font-size: 20px;
        fill: #2b8e59;
      }
    }
  }

  &_indicator {
    background-color: rgb(var(--das-color-primary));
    width: 6px;
    height: 100%;

    &--clean {
    }

    &--dirty {
    }

    &--ready {
    }
  }

  &_group-indicator {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 24px 24px 0;
    border-color: transparent currentColor transparent transparent;

    right: 0;
    top: 0;
    position: absolute;
  }
}
</style>
